// extracted by mini-css-extract-plugin
export default {"colorWhite":"List_colorWhite__gwwQy","dataItem":"List_dataItem__DUfO9","dataList":"List_dataList__RzWFS","btn":"List_btn__TyBvJ"};